// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.grecaptcha-badge {\n  bottom: 140px !important;\n  z-index: 1000 !important;\n}\n", ""]);
// Exports
module.exports = exports;
